import React from "react";

function History() {
  return (
    <div style={{marginBottom:'100px'}}>
      <div className="row banner" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
      <div class="container">

        



        <div class="row" >
          <div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>

          </div>
          <div className="col-md-8 historybox " >
            <h3 className="hheading">41 ദിവസത്തെ വ്രതവും മണിപൂജയും </h3>
            <p className="hcontent">
              അഭിഷ്ട കാര്യസിദ്ധിക്കായി മണി പു ജിച്ച് കെട്ടുന്നത് ഈ ക്ഷേത്രത്തിലെ സവിശേഷതയാണ്. മണി കെട്ടിയ ശേഷം 41 ദിവസം വൃതമാചരിക്കുകയും ഹനുമദ് മന്ത്രം ജപിക്കുകയും വേണം. 41-ാം ദിവസം ഹനുമാൻ സ്വാമിക്ക് നെയ്യ് സമർപ്പിച്ച് വ്രതം അവസാനിപ്പിക്കാം.
            </p>
          </div>
        </div>
        <div class="row" >
          <div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>

          </div>
          <div className="col-md-8 historybox" >
            <h3 className="hheading">ഭാരതത്തിലാദ്യമായി ഹനുമാൻ സ്വാമിയുടെ കളമെഴുത്തു പാട്ടിൻ്റെ തുടക്കം </h3>
            <p className="hcontent">
              ഹനുമാൻ സ്വാമിയുടെ രൂപക്കളമെഴുത്തു പാട്ടിന് മൂന്ന് തലമുറകൾക്ക് മുമ്പ് ഭാരതത്തിൽ ആദ്യമായി മാരുതിപുരം ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രത്തിലാണ് തുടക്കം കുറിച്ചത്. ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്ര നടയിൽ ഹനുമാൻസ്വാമിക്ക് കളമെഴുത്ത് പാട്ട് രചിച്ചതും അവതരിപ്പിച്ചതും കോരുവേലൻ എന്ന മഹാനായ വ്യക്തിയാണ്. ഇന്നും ശ്രീകൃഷ്ണ മാരുതിപുരം ക്ഷേത്രത്തിലെ രോഹിണി മഹോത്സവത്തിലെ പ്രധാന ചടങ്ങ് ഹനുമാൻ സ്വാമിയുടെ രൂപക്കള മെഴുത്തും പാട്ടുമാണ്.
              ക്ഷേത്രം മേൽശാന്തിയായ കാരയിൽ വിഷ്ണുശാന്തിയുടെ നേതൃത്വത്തിൽ കൂടുതൽ ആധ്യാത്മിക തേജസി ലേക്കും അഭിവൃദ്ധിയിലേക്കും വള ർന്നുകൊണ്ടിരിക്കുന്ന ഈ ക്ഷേത്രത്തിലെത്തുന്ന നിരവധി ഭക്തജനങ്ങൾ ഭക്തോത്തമനായ ആഞ്ജനേയ സ്വാമിയുടെ അനുഗ്രഹങ്ങൾ ഏറ്റുവാങ്ങുന്നു.
            </p>
          </div>
        </div>
        <div class="row" >
          <div className="col-md-4 imagebox" style={{ backgroundImage: 'url(./images/makreri.jpeg)', backgrooundPosition: 'center', backgroundSize: 'cover' }}>

          </div>
          <div className="col-md-8 historybox" >
            <h3 className="hheading">ഒമ്പതാം വയസിൽ മേൽശാന്തി</h3>
            <p className="hcontent">
              ശ്രീകൃഷ്ണമാരുതി ക്ഷേത്രത്തിലെ ഹനുമാൻ സ്വാമിയെ പൂജിച്ച് വരുന്ന മൂന്നാം തലമുറക്കാരനാണ് വിഷ്ണുശാന്തി. പിതാമഹൻ കുഞ്ഞിവേലു ആചാര്യൻ. അ ദ്ദേഹത്തിൻ്റെ മകൻ വൈദ്യരത്നം കുട്ടൻ ശാന്തിയുടേയും സജിതയുടേയും മകനാണ്. വളരെ ചെറുപ്പത്തിൽ തന്നെ അച്ഛൻ്റെ ശിക്ഷണത്തിൽ ഹനുമാൻ സ്വാമിയുടെ പൂജ ചെയ്തു തുടങ്ങിയിരുന്നു. തൻ്റെ 9-ാം വയസ്സിൽ അച്ഛൻ്റെ മരണത്തെ തുടർന്ന് ശ്രീകൃഷ്ണ മാരുതി ക്ഷേത്രത്തിലെ മേൽശാന്തിയായി ചുമതലയേറ്റു. ശ്രീ നാരായണ ഗുരു ശിഷ്യ പരമ്പരയിലെ പ്രമുഖനായ കോരു ആശാൻ്റെ ശിഷ്യനായ തറയിൽ സുബ്രഹ്മണ്യ തന്ത്രിയിൽ നിന്ന് പൂജാപഠനവും ബ്രഹ്മ ശ്രീ തിലകൻ തന്ത്രികളിൽ നിന്ന് ഉപരിപഠനവും നേടി. എസ്.എൻ.എം. മാല്യങ്കര കോളേജിൽ ബി.എ മലയാളം പഠനവും 10 വർഷത്തെ ജ്യോതിഷ പഠനജ്ഞാനവും നേടി. ചെറുപ്പം മുതലേ സാമുഹിക പ്രതിബദ്ധത നാമ്പിട്ടിരുന്ന ശ്രീവിഷ്ണുശാന്തി സ്വന്തം വിവാഹത്തിന് ആഡംബരങ്ങളൊക്കെ ഒഴിവാക്കി അതേ വേദിയിൽ നിർദ്ധനയായ മറ്റൊരു പെൺകുട്ടിക്ക് മാംഗല്യ സൗഭാഗ്യമൊരുക്കി സമുഹത്തിന് മാത്യകയായി. അമ്മ സജിത. <br />
              ഭാര്യ: അശ്വതി. മക്കൾ: ബജ്‌രംഗ്, രുദ്രാക്ഷ്. കൃഷിയിൽ സജീവമായ വിഷ്ണുശാന്തിയ്ക്ക് എടവിലങ്ങ് പഞ്ചായത്തിലെ യുവകർഷകനുള്ള പുരസ്ക്കാരവും (2024) ലഭിച്ചു. ശ്രീനാരായണ ഗുരു ദേവ ധർമ്മങ്ങളിൽ അധിഷ്ഠിതമായ പൂജാദികർമ്മങ്ങളും ആത്മീയ ആശയങ്ങളും ഭക്തജന ങ്ങളിലേക്ക് പകർന്നു നൽകുകയും ഇന്ന് കൊടുങ്ങല്ലൂരിലെ പ്രധാന ശാന്തിമാരിൽ ഒരാളായി മാറുകയും ചെയ്തു. ആദ്ധ്യാത്മിക, സാമൂഹ്യസേവന, കാർഷി കമേഖലയിലെല്ലാം വ്യക്തിമുദ്ര പതിപ്പിച്ചാണ് യഥാർത്ഥ ഭക്തിയോടെ, സമർപ്പിതമനസോടെയുളള ഉപാസകനായി വിഷ്ണുശാന്തി ഭഗവാനിൽ സ്വയം സമർപ്പിക്കുന്നത്.

            </p>
          </div>
        </div>


      </div>

    </div>
  );
}

export default History;
